import React from 'react';
import { Card } from './ui/card';
import { Alert, AlertDescription } from './ui/alert';
import { cn } from '@/lib/utils';

interface AuthCardProps {
  children: React.ReactNode;
  className?: string;
}

export const authCardClassName = 'mx-auto w-full max-w-[400px] p-8';

export const AuthCard: React.FC<AuthCardProps> = ({ children, className }) => (
  <Card data-testid="auth-card" className={cn(authCardClassName, className)}>
    {children}
  </Card>
);

export const AuthCardTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <h2 className="mb-6 text-center text-2xl font-semibold text-card-foreground">
    {children}
  </h2>
);

export const AuthCardDescription: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className="mb-6 text-center text-sm text-muted-foreground">
    {children}
  </p>
);

export const AuthFormError: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Alert variant="destructive" className="mb-4">
    <AlertDescription>{children}</AlertDescription>
  </Alert>
);

export const AuthFormSuccess: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Alert className="mb-4 border-[var(--color-success)] text-[var(--color-success)]">
    <AlertDescription>{children}</AlertDescription>
  </Alert>
);

export const AuthTextButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = ({
  className,
  type = 'button',
  ...props
}) => (
  <button
    type={type}
    className={cn('cursor-pointer bg-transparent p-0 text-sm text-foreground underline', className)}
    {...props}
  />
);
